import { type FeatureTestUserVariant } from '~/types/FeatureTest';

import { ActionKeys } from './constants';

export const fetchFeatureTests = () =>
  <const>{
    type: ActionKeys.FETCH_AB_TEST_FEATURES,
  };

export const fetchFeatureTestSuccess = (featureTestUserVariants: FeatureTestUserVariant[]) =>
  <const>{
    payload: {
      featureTestUserVariants,
    },
    type: ActionKeys.FETCH_AB_TEST_FEATURES_SUCCESS,
  };

export const initializeFeatureTestVariantNames = () =>
  <const>{
    type: ActionKeys.INITIALIZE_FEATURE_TEST_VARIANT_NAMES,
  };

export type FeatureTestsActions =
  | ReturnType<typeof fetchFeatureTestSuccess>
  | ReturnType<typeof fetchFeatureTests>
  | ReturnType<typeof initializeFeatureTestVariantNames>;
